// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"9811ef92","191":"af90902e","197":"0d442e5f","639":"886d6e3d","725":"2ea73870","790":"8e527b72","993":"42d1a6dc"}[chunkId] + ".chunk.js";
};